import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useDispatch } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import { updateWorkHistoryByAdmin } from "../../Slices/employeereportslice";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { SelectInput } from "../../blueplanitUtils/InputField";
import { addSingleOverrideHistory } from "../../Slices/employeereportslice";
import { getOptionsByPath } from "../../utilsdata";
import { RECORDS, TASKS } from "../../Dropdownmanager";
export const EmployeeReportModal = ({ show, handleClose, data, isEdit }) => {
  const [initialValues, setInitialValues] = useState({});
  const [hasChanged, setHasChanged] = useState(false);
  const [holdchanges, setchangs] = useState('');
  const dispatch = useDispatch();
  const employees = useSelector((state) => state.loginUserInfo.allUsers);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
  const location = useLocation();
  const currentPath = location.pathname;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [message, setMessage] = useState(data.message || "");
  const [requestId, setRequestId] = useState(data.requestId || "");
  const [taskType, setTask] = useState(data.taskType);
  const taskOptions = getOptionsByPath(
    NestedDatabucket,
    [RECORDS, TASKS]
  );


  const filteredTaskOptions = currentPath === "/ClientReport"
    ? taskOptions.filter(option => !["Calling", "Linkedin", "Data Processing"]?.includes(option.value)) // Keep "Email"
    : taskOptions;



  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);


  const userid = loginUser?.id.toString();
  const employee = employees.find((emp) => emp.id === userid);
  const firstEmailDetail = Array.isArray(data?.emailDetails) && data.emailDetails.length > 0 ? data.emailDetails[0] : {};
  useEffect(() => {
    setTask(data.taskType);
  }, [data.taskType]);

  const handleChange = (value) => {
    setTask(value);
  };

  useEffect(() => {
    const initValues = {
      startDate: data?.startTime || null,
      endDate: data?.endTime || null,
      requestId: data?.requestId || "",
      taskType: data?.taskType || "",
      message: data?.message || "",
    };

    setInitialValues(initValues);
    setStartDate(initValues.startDate);
    setEndDate(initValues.endDate);
    setRequestId(initValues.requestId);
    setMessage(initValues.message);
    setTask(initValues.taskType);
  }, [data]);
  useEffect(() => {
    const currentValues = {
      startDate,
      endDate,
      requestId,
      taskType,
      message,
    };

    const hasAnyChange = Object.keys(currentValues).some(
      (key) => currentValues[key] !== initialValues[key]
    );

    setHasChanged(hasAnyChange);
  }, [startDate, endDate, requestId, taskType, message, initialValues]);


  const employeename = employee
    ? `${employee.firstname} ${employee.lastname}`
    : "Employee not found";

  const handleSaveChanges = () => {
    const startTime = startDate ? startDate.toString() : null;
    const endTime = endDate ? endDate.toString() : null;

    if (endTime < startTime) {
      alert("end date is smaller than the startdate");
      return;
    }

    dispatch(
      updateWorkHistoryByAdmin({
        id: data._id,
        startTime,
        endTime,
        message,
        requestId,
        taskType,
        updatedBy: employeename,
        updatedTime: Date.now().toString(),
        changedArea: holdchanges
      }),
    ).then((res) => {
      dispatch(addSingleOverrideHistory(res.payload));
    });
    handleClose();
  };

  useEffect(() => {
    if (data?.startTime) setStartDate(data.startTime);
    if (data?.endTime) setEndDate(data.endTime);
  }, [data]);
  useEffect(() => {
    if (
      startDate !== initialValues.startDate ||
      endDate !== initialValues.endDate ||
      requestId !== initialValues.requestId ||
      taskType !== initialValues.taskType ||
      message !== initialValues.message
    ) {
      setHasChanged(true);
    } else {
      setHasChanged(false);
    }
  }, [startDate, endDate, requestId, taskType, message, initialValues]);


  const handleClear = () => {
    setStartDate(data.startTime);
    setEndDate(data.endTime);
    setRequestId(data.requestId);
    setTask(data.taskType);

    handleClose();
  };

  const fields = [
    { label: "Employee Name", value: data.employeeName },
    { label: "Email", value: data.emailId },
    { label: "Reporting To", value: data.reportingTo },
  ];

  const clientFields = [
    {
      label: currentPath === "/SalesReport" ? "Agency Name" : "Client Name",
      value: currentPath === "/SalesReport" ? data.agencyName : data.clientName
    },
    ...(currentPath !== "/SalesReport"
      ? [
        { label: "Service", value: data.service },
      ]
      : []),
    { label: "Task", value: data.taskType }
  ];


  const requestFields = [
    { label: "Request", value: firstEmailDetail?.requestId },
    { label: "Request Type", value: firstEmailDetail?.quoteType },
    {
      label: "Processed By",
      value: firstEmailDetail?.assignTo || firstEmailDetail?.assignedTo,
    },
    { label: "Process Type", value: firstEmailDetail?.processType },
    { label: "No. of Quotes Received", value: firstEmailDetail?.noofQuotes },
    { label: "Request Received Date", value: firstEmailDetail?.date },
    { label: "Completed Date", value: firstEmailDetail?.completedDate },
    { label: "Due Date", value: firstEmailDetail?.dueDate },
    {
      label: "Start Date Override",
      value: firstEmailDetail?.startDate,
    },
    {
      label: "Due Date Override",
      value: firstEmailDetail?.dueDate,
    },
    { label: "Department", value: firstEmailDetail?.department },
    { label: "Insured Name", value: firstEmailDetail?.insuredName },
  ];
  const leadFields = [
    { label: "Lead ID", value: data?.leadDetails?.leadID },
    { label: "createdBy", value: data?.leadDetails?.createdBy },
    { label: "assignedTo", value: data?.leadDetails?.assignedTo },
    { label: "priority", value: data?.leadDetails?.priority },
    { label: "status", value: data?.leadDetails?.status },
    { label: "stage", value: data?.leadDetails?.stage },
  ];

  const timerFields = [
    { label: "Start Date & Time", value: startDate },
    { label: "End Date & Time", value: endDate },
    { label: "Duration", value: data.duration },
    { label: "Status", value: data.status },
  ];

  function formatDateTime(timestamp) {
    const date = new Date(parseInt(timestamp));
    if (isNaN(date.getTime())) {
      return "--";
    }
    const options = {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
      timeZone: "Asia/Kolkata",
    };
    return date.toLocaleString("en-IN", options);
  }

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header>

        <div style={{ width: "100%", textAlign: "right" }}>
          {isEdit && (
            <>
              {/* Save Button (Green) */}
              <Button
                onClick={handleSaveChanges}
                disabled={!hasChanged}
                style={{
                  marginRight: "7px",
                  backgroundColor: "#1677ff",
                  padding: "2px 7px",
                  color: "white",
                  opacity: !hasChanged ? 0.5 : 1,
                  cursor: !hasChanged ? "not-allowed" : "pointer",
                }}
              >
                Save
              </Button>

            </>
          )}


          <Button
            onClick={handleClear}
            style={{
              backgroundColor: "rgb(254 60 60)",
              padding: "2px 7px",
              color: "white",
            }}
          >
            X
          </Button>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div>
            <Row
              className="profile-view"
              style={{
                marginTop: "10px",
                position: "relative",
                marginBottom: "25px",
              }}
            >
              <div
                style={{
                  boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.2)",
                  margin: "30px 0px",
                  borderRadius: "10px",
                  padding: "20px",
                }}
              >
                <h5 className="side-heading">Employee Information</h5>
                {fields.map((field, index) => (
                  <Col key={index} md={6} className="field-container">
                    <Form.Label className="field-label">
                      {field.label}
                    </Form.Label>
                    <div className="field-wrapper">
                      {field.label === "Employee Name" ||
                        field.label === "Email" ||
                        field.label === "Reporting To" ? (
                        // Non-editable fields (just display the value)
                        <span className="field-value">{field.value || ""}</span>
                      ) : null}
                    </div>
                  </Col>
                ))}
              </div>
              <div
                style={{
                  boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.2)",
                  margin: "30px 0px",
                  borderRadius: "10px",
                }}
              >
                <h5 className="side-heading">{currentPath === "/SalesReport" ? "Agency Information" : "Client Information"}</h5>
                {clientFields.map((field, index) => (
                  <Col key={index} md={6} className="field-container">
                    <Form.Label className="field-label">
                      {field.label}
                    </Form.Label>
                    <div className="field-wrapper">
                      {isEdit && field.label === "Task" ? (
                        <SelectInput
                          options={filteredTaskOptions}
                          value={taskType}
                          onChange={(e) => {
                            setchangs("Employee Information");
                            handleChange(e);
                          }}
                          placeholder="Select"
                          disabled={!endDate}
                          style={{ width: 150 }}
                        />
                      ) : (
                        <span className="field-value">{field.value || ""}</span>
                      )}
                    </div>
                  </Col>
                ))}
              </div>

              {data?.emailDetails !== "N/A" && (
                <div
                  style={{
                    padding: "20px",
                    boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.2)",
                    margin: "30px 0px",
                    borderRadius: "10px",
                  }}
                >
                  <h5 className="side-heading">Request Information</h5>
                  {requestFields.map((field, index) => (
                    <Col key={index} md={6} className="field-container">
                      <Form.Label className="field-label">
                        {field.label}
                      </Form.Label>
                      <div className="field-wrapper">
                        {isEdit && field.label === "RequestId" ? (
                          <input
                            type="text"
                            className="form-control"
                            placeholder={data.requestId}
                            value={requestId}
                            onChange={(e) => {
                              setchangs("Request Information")
                              setRequestId(e.target.value)
                            }}
                          />
                        ) : field.label === "Request Received Date" ||
                          field.label === "Completed Date" ||
                          field.label === "Due Date" ? (
                          <span className="field-value">
                            {field.value}
                          </span>
                        ) : (
                          <span className="field-value">
                            {field.value || ""}
                          </span>
                        )}
                      </div>
                    </Col>
                  ))}
                </div>
              )}

              {/* Lead Information */}
              {data?.leadDetails !== "N/A" && (
                <div
                  style={{
                    padding: "20px",
                    boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.2)",
                    margin: "30px 0px",
                    borderRadius: "10px",
                  }}
                >
                  <h5 className="side-heading">Lead Information</h5>
                  {leadFields.map((field, index) => (
                    <Col key={index} md={6} className="field-container">
                      <Form.Label className="field-label">
                        {field.label}
                      </Form.Label>
                      <div className="field-wrapper">
                        {/* Just display the value for lead fields */}
                        <span className="field-value">{field.value || ""}</span>
                      </div>
                    </Col>
                  ))}
                </div>
              )}

              <div
                style={{
                  padding: "20px",
                  boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.2)",
                  margin: "30px 0px",
                  borderRadius: "10px",
                }}
              >
                <h5 className="side-heading">Timer Information</h5>
                {timerFields.map((field, index) => (
                  <Col key={index} md={6} className="field-container">
                    <Form.Label className="field-label">
                      {field.label}
                    </Form.Label>
                    <div className="field-wrapper">
                      {field.label === "Start Date & Time" && isEdit ? (
                        // Editable Start Date and Time field
                        <div style={{ marginBottom: "15px" }}>
                          <DatePicker
                            disabled={!endDate}
                            selected={
                              startDate && dayjs(parseInt(startDate)).isValid()
                                ? dayjs(parseInt(startDate)).toDate()
                                : null
                            }
                            onChange={(date) => {
                              setchangs("Timer Information")
                              setStartDate(dayjs(date).valueOf())
                            }
                            }
                            showTimeSelect
                            timeIntervals={15} // Time intervals for time picker
                            className="form-control"
                            placeholderText="Select Start Date and Time"
                            dateFormat="dd/MM/yyyy hh:mm a" // Desired date and time format
                            maxDate={new Date()} // Today's date as max date
                          />
                        </div>
                      ) : field.label === "End Date & Time" && isEdit ? (
                        <div style={{ marginBottom: "15px" }}>
                          <DatePicker
                            disabled={!endDate}
                            selected={
                              endDate && dayjs(parseInt(endDate)).isValid()
                                ? dayjs(parseInt(endDate)).toDate()
                                : null
                            }
                            onChange={(date) => {
                              setchangs("Timer Information")
                              setEndDate(dayjs(date).valueOf())
                            }
                            }
                            showTimeSelect
                            timeIntervals={15}
                            className="form-control"
                            placeholderText="Select End Date and Time"
                            dateFormat="dd/MM/yyyy hh:mm a"
                            minDate={
                              startDate
                                ? dayjs(parseInt(startDate)).toDate()
                                : null
                            }
                            minTime={
                              startDate &&
                                dayjs(parseInt(startDate)).isSame(
                                  dayjs(endDate),
                                  "day"
                                )
                                ? dayjs(parseInt(startDate)).toDate()
                                : new Date(0, 0, 0, 0, 0)
                            }
                            maxTime={new Date(0, 0, 0, 23, 59)}
                            maxDate={new Date()}
                          />
                        </div>
                      ) : field.label === "Start Date & Time" ||
                        field.label === "End Date & Time" ? (
                        <span className="field-value">
                          {formatDateTime(field.value) || " "}
                        </span>
                      ) : (
                        <span className="black-text">
                          {field.value === null ||
                            field.value === undefined ||
                            field.value === "InvalidDate"
                            ? ""
                            : field.value}
                        </span>
                      )}
                    </div>
                  </Col>
                ))}
              </div>
              {data.overrideHistory && data.overrideHistory.length > 0 && (
                <div
                  style={{
                    borderRadius: "10px",
                    boxShadow: "10px 10px 15px rgba(0, 0, 0, 0.2)",
                    marginTop: "30px",
                    marginBottom: "30px",
                    padding: "20px",
                    borderTop: "2px solid #ddd",
                  }}
                >
                  <h5 className="side-heading">Override History</h5>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Overridden By</th>
                        <th> Task</th>
                        <th> Start Time</th>
                        <th> End Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.overrideHistory.length > 0 &&
                        data.overrideHistory.map((override, index) => {

                          return (
                            <tr key={index}>
                              <td>{override.overriddenBy}</td>

                              <td>{override.previousTask}</td>

                              <td>
                                {override.previousstartTime?.includes(" ==> ")
                                  ? override.previousstartTime
                                    .split(" ==> ")
                                    .map((part, index) => (
                                      <>
                                        {part}
                                        {index === 0 && " ==> "}
                                        {index !== 1 && <br />}
                                      </>
                                    ))
                                  : override.previousstartTime}
                              </td>

                              <td>
                                {override.previousendTime?.includes(" ==> ")
                                  ? override.previousendTime
                                    .split(" ==> ")
                                    .map((part, index) => (
                                      <>
                                        {part}
                                        {index === 0 && " ==> "}
                                        {index !== 1 && <br />}
                                      </>
                                    ))
                                  : override.previousendTime}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              )}
            </Row>
          </div>
        </Form>

        <style>{`
          .side-heading {
            color: #0260d2;
            font-weight: bold;
            margin-bottom: 15px;
          }

          .field-label {
            color: #5a5e61;
            font-weight: bold;
            width: 200px;
            text-align: left;
            margin-right: 15px; 
          }

          .field-value {
            flex-grow: 1; 
          }

          .field-container {
            display: flex;
            align-items: center;
            margin-bottom: 10px; 
          }

          .field-wrapper {
            display: flex;
            flex-direction: row;
            width: 100%; 
          }
        `}</style>
      </Modal.Body>
    </Modal>
  );
};

export default EmployeeReportModal;
